import FlagProvider from '@unleash/proxy-client-react'
import { useState } from 'react'
import { I18nextProvider } from 'react-i18next'
import { configureCognito } from '../configs/cognito'
import { unleashClient } from './clients/unleash-client'
import { CognitoAuthProvider } from './contexts/cognitoAuthContext'
import { useOnce } from './hooks/useOnce'
import { AntdLocaleProvider } from './locales/AntdLocaleProvider'
import i18n from './locales/i18n'
import { PersistQueryClientProvider } from './queries/QueryClientProvider'
import { AppRoutes } from './routes'

configureCognito()

const isProduction = process.env.NODE_ENV === 'production'

function App() {
  const [unleashIsReady, setUnleashIsReady] = useState(false)
  useOnce(() => {
    const maybeMockApi = async () => {
      if (!isProduction) {
        await import('./services/mockApi/polly').then(({ startMockServer }) => startMockServer())
      }
      await unleashClient.start()
      setUnleashIsReady(true)
    }
    void maybeMockApi()
  })

  return (
    <FlagProvider unleashClient={unleashClient} startClient={false}>
      <I18nextProvider i18n={i18n}>
        <AntdLocaleProvider language={i18n.language}>
          <CognitoAuthProvider>
            <PersistQueryClientProvider>
              <AppRoutes providersAreReady={unleashIsReady} />
            </PersistQueryClientProvider>
          </CognitoAuthProvider>
        </AntdLocaleProvider>
      </I18nextProvider>
    </FlagProvider>
  )
}

export default App
